<template>
  <div>
    <v-navigation-drawer
      v-model="show"
      enable-resize-watcher
      app
      width="250"
      class="elevation-8 blue lighten-5"
    >
      <v-list>
        <v-list-tile>
          <a href="https://www.poolcalculator.com">
            <v-list-tile-action class="ml-3">
              <v-img
                :aspect-ratio="35 / 28"
                :src="require('@/assets/logo.png')"
                contain
              ></v-img>
            </v-list-tile-action>
          </a>
          <v-list-tile-content>
            <a
              href="https://www.poolcalculator.com"
              style="text-decoration: none !important"
            >
              <v-list-tile-title
                class="text-xs-center subheading indigo--text text--darken-4 font-weight-bold ml-2"
                >Pool Calculator</v-list-tile-title
              >
            </a>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider class="mt-2"></v-divider>

        <div v-if="user.email">
          <v-list-tile-content class="text-xs-center pb-3 mt-4">
            <v-avatar size="100" color="blue darken-1" class="elevation-8">
              <h1 class="display-3 white--text">
                {{ user.firstName.charAt(0).toUpperCase() }}
              </h1>
            </v-avatar>
          </v-list-tile-content>
          <v-list-tile-title
            class="text-xs-center subheading indigo--text text--darken-4"
            >{{ user.firstName }} {{ user.lastName }}</v-list-tile-title
          >
          <v-list-tile-title
            class="text-xs-center subheading indigo--text text--darken-4 font-weight-light"
          >
            {{ user.type }}</v-list-tile-title
          >
        </div>

        <div v-else>
          <v-layout justify-center class="pt-2">
            <v-btn
              x-large
              color="red"
              class="white--text font-weight-bold mt-4"
              @click="$router.push({ name: 'account.register' })"
              >Create Account</v-btn
            >
          </v-layout>
          <v-list-tile-content class="pl-4 pr-4">
            <v-list-tile-title
              class="text-xs-center subheading grey--text text--lighten-1"
              >or</v-list-tile-title
            >
            <v-list-tile-title
              @click="$router.push({ name: 'account.login' })"
              class="text-xs-center pointer subheading indigo--text text--darken-4"
              >Sign In</v-list-tile-title
            >
          </v-list-tile-content>
        </div>
      </v-list>

      <v-list>
        <v-list-group
          v-for="item in items"
          :key="item.title"
          v-model="item.active"
          append-icon="mdi mdi-chevron-down"
        >
          <template v-slot:activator>
            <v-list-tile>
              <v-icon class="indigo--text text--darken-4">{{
                item.icon
              }}</v-icon>
              <v-list-tile-title
                class="pl-3 subheading indigo--text text--darken-4 font-weight-bold"
                >{{ item.title }}</v-list-tile-title
              >
            </v-list-tile>
          </template>

          <v-list-tile
            v-for="choice in item.choices"
            :key="choice.title"
            @click="goToRoute(choice)"
          >
            <v-list-tile-action>
              <v-icon class="pl-4 indigo--text text--darken-4 body-1">{{
                choice.icon
              }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-title class="body-1 indigo--text text--darken-4">{{
              choice.title
            }}</v-list-tile-title>
          </v-list-tile>
        </v-list-group>

        <v-list-tile-content class="pl-4 mt-4">
          <v-list-tile-title
            class="text-xs-left subheading indigo--text text--darken-4"
            style="min-height: 70px"
          >
            <a
              href="https://itunes.apple.com/us/app/pool-calculator/id412876581?mt=8"
              target="_blank"
            >
              <img :src="require('@/assets/app-store2.svg')" alt="iOS App" />
            </a>
          </v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-content class="pl-4">
          <v-list-tile-title
            class="text-xs-left subheading indigo--text text--darken-4"
            style="min-height: 70px"
          >
            <a
              href="https://play.google.com/store/apps/details?id=com.psiflow.poolcalculator&hl=en_US"
              target="_blank"
            >
              <img :src="require('@/assets/play-store2.svg')" alt="iOS App" />
            </a>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list>

      <div class="version">build: {{ version }}</div>
    </v-navigation-drawer>

    <v-toolbar
      fixed
      app
      :clipped-left="clipped"
      color="white"
      id="mobile-toolbar"
    >
      <v-toolbar-side-icon
        @click.stop="show = !show"
        class="indigo--text text--darken-4"
      ></v-toolbar-side-icon>
      <v-spacer />
      <v-toolbar-items>
        <v-btn flat href="https://poolcalculator.com">
          <v-img
            :aspect-ratio="35 / 28"
            :src="require('@/assets/logo.png')"
            contain
          ></v-img>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import firebase from "@/firebase";
export default {
  name: "Navigation",
  data() {
    return {
      show: true,
      clipped: false,
      items: [
        {
          title: "Calculator",
          icon: "mdi mdi-calculator",
          active: true,
          choices: [
            {
              title: "Test",
              icon: "mdi mdi-pencil",
              route: "/",
            },
            {
              title: "Effects",
              icon: "mdi mdi-chart-bubble",
              route: "/effects-calculator",
            },
            {
              title: "Volume",
              icon: "mdi mdi-filter",
              route: "/volume-calculator",
            },
          ],
        },
        {
          title: "Reports",
          icon: "mdi mdi-chart-bar",
          choices: [
            {
              title: "Tests",
              icon: "mdi mdi-pencil",
              route: "/reports/tests",
            },
            {
              title: "Logs",
              icon: "mdi mdi-book-multiple",
              route: "/reports/logs",
            },
          ],
        },
        {
          title: "Settings",
          icon: "mdi mdi-dots-horizontal",
          choices: [
            {
              title: "Tests",
              icon: "mdi mdi-pencil",
              route: "/settings/test",
            },
            {
              title: "Pools",
              icon: "mdi mdi-pool",
              route: "/settings/pools",
            },
            {
              title: "Chemicals",
              icon: "mdi mdi-flask-empty",
              route: "/settings/chemicals",
            },
          ],
        },
        {
          title: "Resources",
          icon: "mdi mdi-book-open",
          choices: [
            {
              title: "Maintenance",
              icon: "mdi mdi-tools",
              route: "",
            },
            {
              title: "Chemistry",
              icon: "mdi mdi-flask",
              route: "",
            },
            {
              title: "Equipment",
              icon: "mdi mdi-air-filter",
              route: "",
            },
            {
              title: "Troubleshooting",
              icon: "mdi mdi-beaker-question",
              route: "",
            },
            {
              title: "Salt Pools",
              icon: "mdi mdi-shaker",
              route: "",
            },
            {
              title: "Hot Tubs",
              icon: "mdi mdi-hot-tub",
              route: "",
            },
          ],
        },
        {
          title: "Account",
          icon: "mdi mdi-account",
          choices: [
            {
              title: "Profile",
              icon: "mdi mdi-file-account",
              route: "/account/profile",
            },
            {
              title: "Billing",
              icon: "mdi mdi-cash-usd",
              route: "/account/billing",
            },
            {
              title: "Logout",
              icon: "mdi mdi-logout-variant",
              route: "/account/login",
            },
          ],
        },
      ],
      version: process.env.VUE_APP_VERSION,
    };
  },
  computed: {
    ...mapGetters({
      user: "user/getUser",
    }),
  },
  methods: {
    ...mapActions({
      initUser: "user/initUser",
    }),
    goToRoute(choice) {
      if (choice.title === "Logout") {
        firebase.auth.signOut().then(() => {
          location.assign("/calculator");
        });
      } else if (choice.title === "Maintenance") {
        window.open(
          "https://www.poolcalculator.com/pool-maintenance/",
          "_blank"
        );
      } else if (choice.title === "Chemistry") {
        window.open("https://www.poolcalculator.com/pool-chemistry/", "_blank");
      } else if (choice.title === "Equipment") {
        window.open("https://www.poolcalculator.com/pool-equipment/", "_blank");
      } else if (choice.title === "Troubleshooting") {
        window.open(
          "https://www.poolcalculator.com/troubleshooting/",
          "_blank"
        );
      } else if (choice.title === "Salt Pools") {
        window.open(
          "https://www.poolcalculator.com/salt-water-pools/",
          "_blank"
        );
      } else if (choice.title === "Hot Tubs") {
        window.open("https://www.poolcalculator.com/hot-tubs/", "_blank");
      }
      this.$router.push(choice.route);
    },
  },
  async created() {
    await this.initUser();
  },
  watch: {
    showNav(newVal, oldVal) {
      console.log(newVal, oldVal);
      this.show = newVal;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-btn {
  border-radius: 0;
}
.pointer {
  cursor: pointer;
}
.v-avatar {
  margin-left: 75px;
}
.fal.v-icon {
  color: #fff !important;
}
.v-list__tile {
  padding-left: 8px;
}
.version {
  position: absolute;
  bottom: 0.5rem;
  left: 0.5rem;
}
#mobile-toolbar {
  display: none;
}
@media (max-width: 768px) {
  #mobile-toolbar {
    display: block;
  }
}
</style>
